import type { Paywall } from "@/react/types";

export const getPaywallTitle = (
  paywall: Pick<Paywall, "event" | "display_name">,
) => {
  let title: string;

  if (paywall?.event?.name) {
    title = paywall.event.name;
  } else {
    title = paywall.display_name;
  }

  return title;
};

export const getPaywallDescription = (
  paywall: Pick<Paywall, "event" | "description">,
) => {
  let description: string | undefined;

  if (paywall.description) {
    description = paywall.description;
  } else if (paywall.event?.body) {
    description = paywall.event?.body;
  }

  return description;
};
